/** Canonical ledger-key formats shared by lazy entry points and sea fares. */
export function newFareKey(): string {
  return `sea-autopilot:${crypto.randomUUID()}`;
}
export function newCombatAutoFireKey(): string {
  return `sea-combat-auto-fire:${crypto.randomUUID()}`;
}
